import { render, staticRenderFns } from "./delFacility.vue?vue&type=template&id=19d6f4e3"
import script from "./delFacility.vue?vue&type=script&lang=js"
export * from "./delFacility.vue?vue&type=script&lang=js"
import style0 from "./delFacility.vue?vue&type=style&index=0&id=19d6f4e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports